// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"About_content-16UMF","collapsed":"About_collapsed-3IhNt","expanded":"About_expanded-OoS1g"};